export {}

const tables = document.querySelectorAll<HTMLElement>(".pd-variants-table")
const mainHeader = document.querySelector(".m-header")

tables.forEach((table) => {
  const scroller = table.querySelector<HTMLElement>(".pd-variants-table__scroller")
  const header = table.querySelector<HTMLElement>(".pd-variants-table__header")
  const body = table.querySelector<HTMLElement>(".pd-variants-table__items")

  if (!scroller || !header || !body) return;

  const syncScroll = () => {
    scroller.scrollLeft = body?.scrollLeft ?? 0
  }

  const handleOffset = () => {
    const height = mainHeader?.clientHeight ?? 0

    if (mainHeader?.classList.contains("headroom--pinned")) {
      header.style.setProperty("top", `${height}px`)
    } else {
      header.style.setProperty("top", "0px")
    }
  }

  body.addEventListener("scroll", syncScroll)
  window.addEventListener("scroll", handleOffset)
})
